var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74375 2.38145C2.25625 1.89395 2.25625 1.1002 2.74375 0.612695C3.23125 0.125195 4.025 0.125195 4.5125 0.612695C5 1.1002 5 1.89395 4.5125 2.38145C4.01875 2.8752 3.23125 2.8752 2.74375 2.38145ZM1.75 9.00019V4.0002C1.75 3.65645 1.46875 3.3752 1.125 3.3752C0.78125 3.3752 0.5 3.65645 0.5 4.0002V9.00019C0.5 10.7252 1.9 12.1252 3.625 12.1252H6.75C7.09375 12.1252 7.375 11.8439 7.375 11.5002C7.375 11.1564 7.09375 10.8752 6.75 10.8752H3.625C2.5875 10.8752 1.75 10.0377 1.75 9.00019ZM10.05 11.0939L7.69375 8.73769C7.4625 8.50644 7.14375 8.37519 6.8125 8.37519H5.1875V6.07519C5.86875 6.63144 6.85 7.13769 7.8125 7.33769C8.23125 7.42519 8.625 7.11269 8.625 6.6877C8.625 6.35644 8.38125 6.08769 8.05 6.03145C7.1625 5.88144 6.25 5.40019 5.70625 4.80019L4.83125 3.83144C4.7125 3.7002 4.5625 3.59395 4.4 3.51894C4.21875 3.43145 4.0125 3.3752 3.8 3.3752H3.78125C3.00625 3.3752 2.375 4.00644 2.375 4.78145V8.37519C2.375 9.41269 3.2125 10.2502 4.25 10.2502H7.41875L9.15625 11.9877C9.4 12.2314 9.80625 12.2314 10.05 11.9877C10.3 11.7439 10.3 11.3439 10.05 11.0939Z",
    fill: "#080403"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.0628909d6d9cda0cbfd3d2ee477ee56a.svg";
export { ForwardRef as ReactComponent };